import { cpnFormatter, translateToLocalDate } from "utils/helpers";

export type DiscrepancyRecord = {
  id?: string | undefined;
  src_id?: string | undefined;
  ANI?: string | undefined;
  CBN?: string | undefined;
  CPF?: string | undefined;
  sop_id?: string | undefined;
  COS?: string | undefined;
  dtype?: string | undefined;
  status?: string | undefined;
  question?: string | undefined;
  ticket?: string | undefined;
  age?: string | undefined;
  last_modified?: string | undefined;
  occurred?: string | undefined;
  submitted?: string | undefined;
  viewable?: string | undefined;
  resolved?: string | undefined;
  verified?: string | undefined;
  completed?: string | undefined;
  created_by?: string | undefined;
  submitted_by?: string | undefined;
  modified_by?: string | undefined;
  web_login?: string | undefined;
  state?: string | undefined;
  county?: string | undefined;
  inESN?: string | undefined;
  jurisdiction?: string | undefined;
  software_src?: string | undefined;
  table_name?: string | undefined;
};

export const remove = (cell, formatterParams, onRendered) => {
  return `<calcite-icon id="trashIcon" icon="trash" scale="s"></calcite-icon>`;
};

export const options = (cell, formatterParams, onRendered) => {
  let id = cell.getData().id;
  let hasEditPermission = formatterParams?.hasEditPermission;
  let hasAliViewPermission = formatterParams?.hasAliViewPermission;
  let opts = "";
  if (hasAliViewPermission) {
    opts += `<a href="#" title="View Discrepancy Records" onclick="localStorage.removeItem('discrepancyRecords-criteria'); localStorage.setItem('discrepancyRecords-criteria', JSON.stringify([{field: 'msag_id', type: 'like', value: '${id}'}])); window.location.href='/discrepancy-records'; return false;"><calcite-icon icon="pin-tear" scale="s" style="margin-right:8px;"></calcite-icon></a>`;
  }
  // if (hasEditPermission) {
  //   return (
  //     opts +
  //     `<a href="/msag-records/` +
  //     id +
  //     `"><calcite-icon id="editRecord-` +
  //     id +
  //     `" icon="pencil" scale="s" style="margin-right:8px;"></calcite-icon></a>
  //           <calcite-icon id="deleteRecord-` +
  //     id +
  //     `" icon="trash" scale="s"></calcite-icon>`
  //   );
  // } else {
  return (
    opts +
    `<a href="/discrepancies/view/` +
    id +
    `" title="View Discrepancy"><calcite-icon id="viewDiscrepancy-` +
    id +
    `" icon="annotate-tool" scale="s"></calcite-icon></a>`
  );
  // }
};

export function getDiscrepancyColumn(
  hasEditPermission: boolean,
  hasAliViewPermission: boolean,
): ColumnDefinition[] {
  return [
    // Displayed columns
    {
      title: "",
      field: "actions",
      formatter: options,
      formatterParams: {
        hasEditPermission,
        hasAliViewPermission,
      },
      width: 75,
      minWidth: 50,
      hozAlign: "center",
      headerSort: false,
      headerFilter: false,
    },
    {
      title: "ID",
      field: "id",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 135,
      // minWidth: 50,
    },
    {
      title: "ANI",
      field: "ANI",
      formatter: cpnFormatter,
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 185,
      // minWidth: 120,
    },
    {
      title: "CBN",
      field: "CBN",
      formatter: cpnFormatter,
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 185,
      // minWidth: 120,
    },
    {
      title: "Status",
      field: "status",
      headerFilter: "select",
      headerFilterParams: {
        values: [
          "",
          "Unvetted",
          "New",
          "Notified",
          "Resolved",
          "Verified",
          "Completed",
        ],
      },
      headerFilterLiveFilter: true,
      width: 185,
      // minWidth: 120,
    },
    {
      title: "Type",
      field: "dtype",
      headerFilter: "select",
      headerFilterParams: {
        values: [
          "",
          "ALIincorrect",
          "ANI",
          "ChangeRequest",
          "GIS",
          "LVF",
          "Misroute",
          "MSAGrequest",
          "NRF",
          "Other",
        ],
      },
      headerFilterLiveFilter: true,
      width: 155,
      // minWidth: 50,
    },
    {
      title: "Creator",
      field: "submitted_by",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 200,
      // minWidth: 50,
    },
    {
      title: "Time of Incident",
      field: "occurred",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 170,
      // minWidth: 50,
    },
    {
      title: "Time Elapsed",
      field: "age",
      formatter: function (cell) {
        var age = cell.getRow().getData().age;
        if (!age) return "";
        let status = cell.getRow().getData().status;
        let c = cell.getElement();
        if (age >= 2 && status !== "Completed" && status !== "Resolved") {
          c.style.backgroundColor = "#f87171";
        }
        return age === 1 ? age + " day" : age + " days";
      },
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 135,
      // minWidth: 60,
    },
    {
      title: "COS",
      field: "COS",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 135,
      // minWidth: 50,
    },
    {
      title: "Jurisdiction",
      field: "jurisdiction",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 155,
      // minWidth: 50,
    },
    {
      title: "NENA ID",
      field: "CPF",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 230,
      // minWidth: 110,
    },
    {
      title: "County",
      field: "county",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 135,
    },
    {
      title: "State",
      field: "state",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 135,
    },
    {
      title: "Last Modified",
      field: "last_modified",
      mutator: translateToLocalDate,
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 175,
    },
  ];
}

export function getDiscrepancyExportColumns() {
  return {
    ID: "ID",
    ANI: "ANI",
    CBN: "CBN",
    Status: "Status",
    Type: "dType",
    Creator: "Submitted_By",
    "Time of Incident": "Occurred",
    COS: "COS",
    Jurisdiction: "Jurisdiction",
    "NENA ID": "CPF",
    State: "State",
    County: "County",
    "Last Modified": "Last_Modified",
    Resolved: "Resolved",
    Completed: "Completed",
  };
}
